import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { IntlProvider } from 'react-intl';
import messages from './i18n/messages';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Citizenship from './pages/Citizenship';
import Spain from './pages/Citizenship/Spain';
import Belgium from './pages/Citizenship/Belgium';
import France from './pages/Citizenship/France';
import USGreenCard from './pages/USGreenCard';
import EB1ANIW from './pages/USGreenCard/EB1ANIW';
import EB1C from './pages/USGreenCard/EB1C';
import EB5 from './pages/USGreenCard/EB5';
import TwinLakes from './pages/Projects/twinlakes';
import SantaCruz from './pages/Projects/santacruz';
import OtherCitizenship from './pages/OtherCitizenship';
import Croatia from './pages/OtherCitizenship/Croatia';
import Turkey from './pages/Citizenship/Turkey';
import StLucia from './pages/Citizenship/StLucia';
import Dominica from './pages/Citizenship/Dominica';
import Greece from './pages/OtherCitizenship/Greece';
import Japan from './pages/OtherCitizenship/Japan';
import Malta from './pages/OtherCitizenship/Malta';
import JingningLu from './pages/team/JingningLu';
import JiaruiYin from './pages/team/JiaruiYin';
import YanbingLu from './pages/team/YanbingLu';
import BrianMcGrane from './pages/team/BrianMcGrane';
import CrystalBraveboyChetram from './pages/team/CrystalBraveboyChetram';
import DenizEdaCardak from './pages/team/DenizEdaCardak';
import MatiasApparcel from './pages/team/MatiasApparcel';
import MischaMannixOpie from './pages/team/MischaMannixOpie';
import OtherBelgium from './pages/OtherCitizenship/Belgium';
import OtherSpain from './pages/OtherCitizenship/Spain';
import Slovenia from './pages/Citizenship/Slovenia';
import Argentina from './pages/Citizenship/Argentina';
import Mexico from './pages/Citizenship/Mexico';
import OtherFrance from './pages/OtherCitizenship/France';
import OtherPrograms from './pages/OtherPrograms';
import Paraguay from './pages/OtherCitizenship/Paraguay';
import Chile from './pages/Citizenship/Chile';
import Portugal from './pages/Citizenship/Portugal';
import NewZealand from './pages/Citizenship/NewZealand';
import { Analytics } from "@vercel/analytics/react"

type Locale = 'en' | 'zh';

interface LanguageContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const LanguageContext = React.createContext<LanguageContextType>({
  locale: 'en',
  setLocale: () => {},
});

const App: React.FC = () => {
  const [locale, setLocale] = useState<Locale>('en');
  const theme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#dc004e',
      },
    },
  });

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/citizenship" element={<Citizenship />} />
              <Route path="/citizenship/spain" element={<Spain />} />
              <Route path="/citizenship/belgium" element={<Belgium />} />
              <Route path="/citizenship/france" element={<France />} />
              <Route path="/citizenship/mexico" element={<Mexico />} />
              <Route path="/citizenship/argentina" element={<Argentina />} />
              <Route path="/citizenship/slovenia" element={<Slovenia />} />
              <Route path="/citizenship/turkey" element={<Turkey />} />
              <Route path="/citizenship/chile" element={<Chile />} />
              <Route path="/citizenship/portugal" element={<Portugal />} />
              <Route path="/citizenship/new-zealand" element={<NewZealand />} />
              <Route path="/us-green-card" element={<USGreenCard />} />
              <Route path="/us-green-card/eb1a-niw" element={<EB1ANIW />} />
              <Route path="/us-green-card/eb1c" element={<EB1C />} />
              <Route path="/us-green-card/eb5" element={<EB5 />} />
              <Route path="/projects/twinlakes" element={<TwinLakes />} />
              <Route path="/projects/santacruz" element={<SantaCruz />} />
              <Route path="/other-citizenship" element={<OtherCitizenship />} />
              <Route path="/other-citizenship/turkey" element={<Turkey />} />
              <Route path="/citizenship/st-lucia" element={<StLucia />} />
              <Route path="/citizenship/dominica" element={<Dominica />} />
              <Route path="/other-citizenship/croatia" element={<Croatia />} />
              <Route path="/other-citizenship/greece" element={<Greece />} />
              <Route path="/other-citizenship/japan" element={<Japan />} />
              <Route path="/other-citizenship/malta" element={<Malta />} />
              <Route path="/other-citizenship/belgium" element={<OtherBelgium />} />
              <Route path="/other-citizenship/spain" element={<OtherSpain />} />
              <Route path="/other-citizenship/france" element={<OtherFrance />} />
              <Route path="/other-citizenship/paraguay" element={<Paraguay />} />
              <Route path="/other-programs" element={<OtherPrograms />} />
              <Route path="/team/jingning-lu" element={<JingningLu />} />
              <Route path="/team/jiarui-yin" element={<JiaruiYin />} />
              <Route path="/team/yanbing-lu" element={<YanbingLu />} />
              <Route path="/team/brian-mcgrane" element={<BrianMcGrane />} />
              <Route path="/team/crystal-braveboy-chetram" element={<CrystalBraveboyChetram />} />
              <Route path="/team/deniz-eda-cardak" element={<DenizEdaCardak />} />
              <Route path="/team/matias-apparcel" element={<MatiasApparcel />} />
              <Route path="/team/mischa-mannix-opie" element={<MischaMannixOpie />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export default App; 